import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import SliderHomeItem from "./Items/SliderHomeItem";
import { Pagination, Autoplay } from 'swiper/modules';

export default function SliderGeneral({ Slides }) {

    //Slider home page (Can be general just need add some props when added new slides)
    return (
        <Swiper
            slidesPerView={1}
            pagination={true}
            loop={true}
            style={{height: "100%"}}
            autoplay={{
                delay: 4000,
                disableOnInteraction: false,
            }}
            modules={[Autoplay, Pagination]}
        >
            {Slides.map((val, i) => {
                return (
                    <SwiperSlide style={{height: "100%"}} key={i}>
                        <SliderHomeItem data={val} />
                    </SwiperSlide>
                )
            })}
        </Swiper>
    )
}

